<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="12" class="d-flex py-0">
        <v-btn small class="px-0 text-capitalize" @click="$router.back()" text color="pink darken-1">
          <v-icon size="15" class="mr-1">mdi-arrow-left</v-icon>
          {{ $t("YAZILAR.CATEGORIES.GO_BACK_TO_LIST_BTN") }}
        </v-btn>
      </v-col>
      <v-col lg="6">
        <h1 class="title font-weight-light mb-2 black--text">
          <v-icon left color="black">mdi-format-list-bulleted</v-icon>
          <span id="widgetNameEdit">{{ $t("YAZILAR.CATEGORIES.LIST_CATEGORY_TITLE") }}</span>
          <v-divider class="mt-2"></v-divider>
        </h1>
        <p class="text-caption grey--text text--darken-2 mb-2">
          {{ $t("YAZILAR.CATEGORIES.LIST_CATEGORY_SUB_TITLE") }}
        </p>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :items="hiyerarsikKategoriler"
              :headers="kategorilerTable.headers"
              :no-data-text="kategorilerTable.noDataText"
              :loading-text="kategorilerTable.loadingText"
              :loading="kategorilerTable.listStatus"
              class="elevation-1"
              calculate-widths
              hide-default-footer
            >
              <template v-slot:item.id="{ item }">
                <v-chip class="font-weight-light" small color="grey lighten-4">{{ item.code }}</v-chip>
              </template>
              <template v-slot:item.name="{ item }">
                <span class="d-block ml-1 font-weight-medium">{{ item.name }}</span>
              </template>
              <template v-slot:item.code="{ item }">
                <v-tooltip bottom color="blue darken-3 white--text">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      fab
                      x-small
                      color="blue lighten-4"
                      class="elevation-0 mr-2"
                      @click="kategoriDuzenle(item.code)"
                      :loading="kategoriDuzenleLoading[item.code]"
                    >
                      <v-icon small color="blue darken-3">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("YAZILAR.CATEGORIES.CATEGORY_LIST.EDIT_CATEGORY_BTN") }}</span>
                </v-tooltip>
                <v-tooltip bottom color="red darken-3 white--text">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      fab
                      x-small
                      color="red lighten-4"
                      class="elevation-0"
                      @click="kategoriKaldirDialog(item.code)"
                      :loading="kategoriKaldirLoading[item.code]"
                    >
                      <v-icon small color="red darken-3">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("YAZILAR.CATEGORIES.CATEGORY_LIST.DELETE_CATEGORY_BTN") }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" class="white elevation-1">
        <div class="d-flex align-center py-0 px-0">
          <h1 v-if="!duzenlenenKategori" class="title font-weight-light black--text">
            <v-icon left color="black">mdi-playlist-plus</v-icon>
            {{ $t("YAZILAR.CATEGORIES.ADD_CATEGORY_TITLE") }}
          </h1>
          <h1 v-else class="title font-weight-light black--text">
            <v-icon left color="black">mdi-refresh</v-icon>
            {{ $t("YAZILAR.CATEGORIES.EDIT_CATEGORY_TITLE") }}
          </h1>
        </div>
        <v-divider class="mb-2 mt-2"></v-divider>
        <p v-if="!duzenlenenKategori" class="text-caption grey--text text--darken-2 mb-2">{{ $t("YAZILAR.CATEGORIES.ADD_CATEGORY_SUB_TITLE") }}</p>
        <p v-else class="text-caption grey--text text--darken-2 mb-2">
          {{ $t("YAZILAR.CATEGORIES.EDIT_CATEGORY_SUB_TITLE") }}:
          <b>{{ duzenlenenKategoriName }}</b>
        </p>
        <v-row>
          <v-col cols="12" class="pb-1">
            <p class="text-subtitle-2 grey--text text--darken-3 font-weight-regular mb-0">
              <b class="blue--text">{{ $t("YAZILAR.CATEGORIES.ADD_CATEGORY_INFO.TITLE") }}:</b>
              {{ $t("YAZILAR.CATEGORIES.ADD_CATEGORY_INFO.DESC") }}
            </p>
          </v-col>
          <v-col cols="12" lg="12">
            <v-text-field
              prepend-inner-icon="mdi-chevron-right"
              class="mb-4 font-weight-light"
              :label="$t('YAZILAR.CATEGORIES.CATEGORY_NAME_LABEL')"
              hide-details
              outlined
              filled
              dense
              v-model="kategoriData.kategoriAdi"
            ></v-text-field>
            <v-text-field
              prepend-inner-icon="mdi-chevron-right"
              class="mb-1 font-weight-light"
              :label="$t('YAZILAR.CATEGORIES.CATEGORY_DESC_LABEL')"
              :hint="$t('YAZILAR.CATEGORIES.CATEGORY_DESC_HINT')"
              persistent-hint
              outlined
              filled
              dense
              v-model="kategoriData.kategoriAciklamasi"
            ></v-text-field>
            <v-select
              prepend-inner-icon="mdi-chevron-right"
              :hint="$t('YAZILAR.CATEGORIES.CATEGORY_PARENT_HINT')"
              persistent-hint
              :items="selectUrunKategorileri()"
              item-text="name"
              item-value="code"
              class="mb-3 font-weight-light"
              outlined
              filled
              dense
              :label="$t('YAZILAR.CATEGORIES.CATEGORY_PARENT_LABEL')"
              clearable
              :default-value="0"
              v-model="kategoriData.kategoriEbeveyni"
            ></v-select>
            <div v-if="!duzenlenenKategori" class="d-flex justify-end">
              <v-btn outlined color="blue" dark @click="kategoriEkle" :loading="kategoriEkleDuzenleLoading">
                <v-icon left>mdi-plus-circle</v-icon>
                {{ $t("YAZILAR.CATEGORIES.ADD_CATEGORY_BTN") }}
              </v-btn>
            </div>
            <div v-else class="d-flex justify-end">
              <v-btn outlined color="red darken-2" class="mr-3" dark @click="kategoriEkleForm">
                {{ $t("YAZILAR.CATEGORIES.EDIT_CATEGORY_CANCEL_BTN") }}
              </v-btn>
              <v-btn outlined color="green" dark @click="kategoriGuncelle" :loading="kategoriEkleDuzenleLoading">
                <v-icon left>mdi-refresh</v-icon>
                {{ $t("YAZILAR.CATEGORIES.EDIT_CATEGORY_BTN") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="kategorilerTable.listStatus" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <div class="py-2 text-center">{{ $t("YAZILAR.CATEGORIES.LOADING_CATEGORIES") }}</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="500" v-model="kategoriKaldirDialogStatus">
      <v-card>
        <v-card-title class="red--text text--darken-2">
          <span class="mr-2">{{ $t("YAZILAR.CATEGORIES.DELETE_CATEGORY_DIALOG.TITLE") }}</span>
          <v-divider></v-divider>
        </v-card-title>
        <v-card-text class="text-body-2">{{ $t("YAZILAR.CATEGORIES.DELETE_CATEGORY_DIALOG.INFO_WARN") }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-2" text @click="kategoriKaldirDialogStatus = false">
            {{ $t("YAZILAR.CATEGORIES.DELETE_CATEGORY_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green" text @click="kategoriKaldir">
            <v-icon left>mdi-check</v-icon>
            {{ $t("YAZILAR.CATEGORIES.DELETE_CATEGORY_DIALOG.DELETE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import YazilarService from "@/services/YazilarService";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";

export default {
  name: "YaziKategorileri",
  props: {
    state: {}
  },
  data() {
    return {
      kategorilerTable: {
        headers: [
          { text: this.$t("YAZILAR.CATEGORIES.TABLE_FIELDS.ID"), value: "id", sortable: false, width: '15px' },
          { text: this.$t("YAZILAR.CATEGORIES.TABLE_FIELDS.TITLE"), value: "name", sortable: false, align: "start" },
          { text: this.$t("YAZILAR.CATEGORIES.TABLE_FIELDS.DESC"), value: "desc", sortable: false, align: "start" },
          { text: this.$t("YAZILAR.CATEGORIES.TABLE_FIELDS.ACTIONS"), value: "code", sortable: false, align: "end" }
        ],
        noDataText: this.$t("YAZILAR.CATEGORIES.NO_CATEGORY_ADDITIONAL"),
        loadingText: this.$t("YAZILAR.CATEGORIES.LOADING_CATEGORIES_ON_TABLE"),
        yaziListesi: [],
        listStatus: true
      },
      kategoriData: {
        kategoriAdi: "",
        kategoriAciklamasi: "",
        kategoriEbeveyni: 0
      },
      duzenlenenKategori: false,
      kategoriKaldirDialogStatus: false,
      silinecekKategori: "",
      catsStatus: true,
      hiyerarsikKategoriler: [],
      kategoriDuzenleLoading: [],
      kategoriKaldirLoading: [],
      kategoriEkleDuzenleLoading: false
    };
  },
  computed: {
    ...mapState({
      kategoriListesi: state => state.Yazilar.YaziKategorileri.kategoriListesi
    }),
    ...mapGetters({
      kategorilerGrouped: "Yazilar/YaziKategorileri/kategorilerGrouped"
    }),
    duzenlenenKategoriName() {
      return _.find(this.kategoriListesi, {
        code: this.duzenlenenKategori
      }).name;
    }
  },
  methods: {
    selectUrunKategorileri() {
      let sayfaListesiHrk = this.kategorilerGrouped(this.kategoriListesi),
        sayfaListesi = [];
      for (let group of sayfaListesiHrk) {
        for (let page of group) {
          page.name = this.depthLine(page.depth) + " " + page.name;
          sayfaListesi.push(page);
        }
      }

      if (this.duzenlenenKategori) {
        /**
         * Güncelleme verisindeki kategorinin alt sayfalarını seçilemeyecek
         * biçimde iptal et
         */
        let code = this.duzenlenenKategori,
          category = _.find(sayfaListesi, { code: code }),
          hierarchy = _.find(sayfaListesi, {
            hierarchy: category.hierarchy
          }),
          hierarchyCode = hierarchy.hierarchy;

        let sayfaGuncelleParent = _.filter(sayfaListesi, s => s.hierarchy === hierarchyCode),
          page = _.find(sayfaGuncelleParent, s => {
            return s.code === code;
          });

        let guncelSayfaListesi = sayfaListesi;
        _.remove(guncelSayfaListesi, s => {
          return (s.depth > page.depth && s.hierarchy === hierarchyCode) || s.code === code;
        });

        sayfaListesi = guncelSayfaListesi;
      }
      return sayfaListesi;
    },
    /**
     * Yeni kategori eklmesi yapar
     */
    kategoriEkle() {
      const { kategoriAdi, kategoriAciklamasi, kategoriEbeveyni } = this.kategoriData;
      this.kategoriEkleDuzenleLoading = true;
      this.$store
        .dispatch("Yazilar/YaziKategorileri/kategoriEkle", {
          kategoriAdi,
          kategoriAciklamasi,
          kategoriEbeveyni
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.CATEGORY_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.kategoriEkleForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriEkleDuzenleLoading = false;
        });
    },
    /**
     * Herhangi bir kategoriyi düzenlemek için
     * ürün detayını getir ve kategori ekleme formu
     * üzerine işleme yap
     */
    kategoriDuzenle(kategoriCode) {
      this.kategoriDuzenleLoading[kategoriCode] = true;
      YazilarService.kategoriDetay({ kategoriCode })
        .then(res => {
          if (res.status === 200) {
            this.kategoriData.kategoriAdi = res.data.name;
            this.kategoriData.kategoriAciklamasi = res.data.desc;
            this.kategoriData.kategoriEbeveyni = res.data.parent;
            this.duzenlenenKategori = kategoriCode;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriDuzenleLoading[kategoriCode] = false;
        });
    },
    kategoriGuncelle() {
      let kategoriCode = this.duzenlenenKategori;
      const { kategoriAdi, kategoriAciklamasi, kategoriEbeveyni } = this.kategoriData;
      this.kategoriEkleDuzenleLoading = true;
      this.$store
        .dispatch("Yazilar/YaziKategorileri/kategoriGuncelle", {
          kategoriCode,
          kategoriAdi,
          kategoriAciklamasi,
          kategoriEbeveyni
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.CATEGORY_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.kategoriEkleForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriEkleDuzenleLoading = false;
        });
    },
    kategoriKaldir() {
      let kategoriCode = this.silinecekKategori;
      this.kategoriKaldirLoading[kategoriCode] = true;
      this.$store
        .dispatch("Yazilar/YaziKategorileri/kategoriKaldir", { kategoriCode })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.CATEGORY_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.kategoriEkleForm();
            this.silinecekKategori = "";
            this.kategoriKaldirDialogStatus = false;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kategoriKaldirLoading[kategoriCode] = false;
        });
    },
    kategoriKaldirDialog(kategoriCode) {
      this.silinecekKategori = kategoriCode;
      this.kategoriKaldirDialogStatus = true;
    },
    kategoriEkleForm() {
      this.kategoriData.kategoriAdi = "";
      this.kategoriData.kategoriAciklamasi = "";
      this.kategoriData.kategoriEbeveyni = 0;
      this.duzenlenenKategori = false;
      this.kategoriDuzenleLoading = [];
    },
    depthLine(length) {
      let lines = "";
      for (let i = 0; i < length; i++) {
        lines += "—";
      }
      return lines;
    },
    generateGroupedCategories(kategoriList) {
      let sayfaListesiHrk = this.kategorilerGrouped(kategoriList),
        sayfaListesi = [];

      for (let group of sayfaListesiHrk) {
        for (let page of group) {
          page.name = this.depthLine(page.depth) + " " + page.name;
          sayfaListesi.push(page);
        }
      }
      return _.sortBy(sayfaListesi, ['code']);
    }
  },
  created() {
    /**
     * Urun Kategorilerinin Listesini Getir
     */
    this.$store
      .dispatch("Yazilar/YaziKategorileri/kategoriListesi")
      .then(res => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            this.hiyerarsikKategoriler = this.generateGroupedCategories(res.data);
          }
        }
        this.kategorilerTable.listStatus = false;
      })
      .then(() => {
        /**
         * Store değikliklerini dinle ve değişiklik durumunda kategorileri tekrar güncelle
         */
        this.$store.watch(
          state => state.Yazilar.YaziKategorileri.kategoriListesi,
          newData => {
            this.hiyerarsikKategoriler = this.generateGroupedCategories(newData);
          }
        );
      });

    //   if (res.status === 200) {
    //
    //   }
  },
  watch: {
    "kategoriData.kategoriEbeveyni"(val) {
      this.kategoriData.kategoriEbeveyni = val ?? 0;
    }
  }
};
</script>
